import React, { useEffect, useState } from "react";
import { useLoaderData, useParams } from "react-router-dom";
import Contract from "./ProductDetailsTabPages/Contract";
import Fulfillment from "./ProductDetailsTabPages/Fulfillment";
import Billing from "./ProductDetailsTabPages/Billing";
import CustomerView from "./ProductDetailsTabPages/CustomerView";
import OrderModify from "./ProductDetailsTabPages/OrderModify";
import PaymentRecord from "./ProductDetailsTabPages/PaymentRecord";
import OrderModifyTwo from "./ProductDetailsTabPages/OrderModifyTwo";

const ProjectDetails = () => {
  const { id } = useParams(); // Get the 'id' from route params
  const [products, setProducts] = useState(null); // State for real-time product data
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = localStorage.getItem('activeTab');
    return savedTab ? parseInt(savedTab, 10) : 1;
  });

  // Save the active tab to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('activeTab', activeTab);
  }, [activeTab]);

  const handleTabChange = (tabNumber) => {
    setActiveTab(tabNumber);
  };

  // Function to fetch product details
  const fetchProductDetails = async () => {
    try {
      const response = await fetch(`https://server-gs.vercel.app/admin/orders/${id}`);
      const data = await response.json();
      setProducts(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching product details:", error);
    }
  };

  useEffect(() => {
    fetchProductDetails(); // Initial fetch

    // Polling every 5 seconds
    const interval = setInterval(() => {
      fetchProductDetails();
    }, 1000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [id]);

  if (loading) return <div>Loading...</div>;

  console.log(products);



  return (
    <div>
      <div className="w-full h-[200px] bg-gray-700 flex flex-col justify-between">
        <div className=" h-20 w-full flex flex-row justify-between p-5">
          <div className="w-[40%] h-full ">
            <h1 className="font-semibold text-2xl font-roboto text-white">
              {products.firstName} {products.lastName}
            </h1>
          </div>
          <div className="w-[40%] h-full flex justify-end">
            <img
              className="w-8 h-8"
              alt=""
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTMyOS45NTYgMzk5LjgzNEgxODIuMDQ0Yy05LjQyNSAwLTE3LjA2NyA3LjY0MS0xNy4wNjcgMTcuMDY3czcuNjQxIDE3LjA2NyAxNy4wNjcgMTcuMDY3aDE0Ny45MTFjOS40MjUgMCAxNy4wNjctNy42NDEgMTcuMDY3LTE3LjA2N3MtNy42NDEtMTcuMDY3LTE3LjA2Ni0xNy4wNjd6TTMyOS45NTYgMzQ2LjAwNkgxODIuMDQ0Yy05LjQyNSAwLTE3LjA2NyA3LjY0MS0xNy4wNjcgMTcuMDY3czcuNjQxIDE3LjA2NyAxNy4wNjcgMTcuMDY3aDE0Ny45MTFjOS40MjUgMCAxNy4wNjctNy42NDEgMTcuMDY3LTE3LjA2N3MtNy42NDEtMTcuMDY3LTE3LjA2Ni0xNy4wNjd6IiBmaWxsPSIjZmZmZmZmIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iIj48L3BhdGg+PHBhdGggZD0iTTQ3Mi4xNzggMTMzLjkwN2gtNTQuMzAzVjM1LjEzMmMwLTkuNDI1LTcuNjQxLTE3LjA2Ny0xNy4wNjctMTcuMDY3SDExMS4xOTJjLTkuNDI1IDAtMTcuMDY3IDcuNjQxLTE3LjA2NyAxNy4wNjd2OTguNzc1SDM5LjgyMkMxNy44NjQgMTMzLjkwNyAwIDE1MS43NzIgMCAxNzMuNzN2MTcxLjcwMmMwIDIxLjk1OCAxNy44NjQgMzkuODIyIDM5LjgyMiAzOS44MjJoNTQuMzA2djkxLjYxNGMwIDkuNDI1IDcuNjQxIDE3LjA2NyAxNy4wNjcgMTcuMDY3aDI4OS42MWM5LjQyNSAwIDE3LjA2Ny03LjY0MSAxNy4wNjctMTcuMDY3di05MS42MTRoNTQuMzA2YzIxLjk1OCAwIDM5LjgyMi0xNy44NjQgMzkuODIyLTM5LjgyMlYxNzMuNzNjMC0yMS45NTctMTcuODY0LTM5LjgyMy0zOS44MjItMzkuODIzem0tMzQzLjkyLTgxLjcwOGgyNTUuNDgzdjgxLjcwOEgxMjguMjU4VjUyLjE5OXptMjU1LjQ4IDQwNy42MDJIMTI4LjI2MlYzMjAuMTczaDI1NS40NzdsLS4wMDEgMTM5LjYyOHptMTcuMDctMjI1LjY3OWgtNDMuNDQzYy05LjQyNSAwLTE3LjA2Ny03LjY0MS0xNy4wNjctMTcuMDY3czcuNjQxLTE3LjA2NyAxNy4wNjctMTcuMDY3aDQzLjQ0M2M5LjQyNSAwIDE3LjA2NyA3LjY0MSAxNy4wNjcgMTcuMDY3cy03LjY0MSAxNy4wNjctMTcuMDY3IDE3LjA2N3oiIGZpbGw9IiNmZmZmZmYiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSIiPjwvcGF0aD48L2c+PC9zdmc+"
            />
          </div>
        </div>
        <div className=" w-full flex justify-center items-center">
          <div className="flex space-x-4">
            <button
              onClick={() => handleTabChange(1)}
              className={`px-6 py-4 text-xl font-roboto  ${
                activeTab === 1
                  ? "bg-blue-100 text-gray-900"
                  : "bg-gray-900 text-gray-100"
              }`}
            >
              Contract
            </button>
            <button
              onClick={() => handleTabChange(2)}
              className={`px-6 py-4 text-xl font-roboto  ${
                activeTab === 2
                  ? "bg-blue-100 text-gray-900"
                  : "bg-gray-900 text-gray-100"
              }`}
            >
              Payment Record
            </button>
            {/* <button
              onClick={() => handleTabChange(2)}
              className={`px-6 py-4 text-xl font-roboto  ${
                activeTab === 2
                  ? "bg-blue-100 text-gray-900"
                  : "bg-gray-900 text-gray-100"
              }`}
            >
              Billing
            </button> */}
            {/* <button
              onClick={() => handleTabChange(3)}
              className={`px-6 py-4 text-xl font-roboto  ${
                activeTab === 3
                  ? "bg-blue-100 text-gray-900"
                  : "bg-gray-900 text-gray-100"
              }`}
            >
              Fulfillment
            </button> */}
            {/* <button
              onClick={() => handleTabChange(3)}
              className={`px-6 py-4 text-xl font-roboto  ${
                activeTab === 3
                  ? "bg-blue-100 text-gray-900"
                  : "bg-gray-900 text-gray-100"
              }`}
            >
              Fulfillment
            </button> */}
          </div>
        </div>
      </div>

      {/* Buttons for Tabs */}

      {/* Tab Content */}
      <div>
        {activeTab === 1 && (
          <div>
            {/* <Contract products={products}></Contract> */}
            {/* <OrderModify products={products}></OrderModify> */}
            <OrderModifyTwo products={products}></OrderModifyTwo>
          </div>
        )}
        {activeTab === 2 && (
          <div>
            <PaymentRecord products={products}></PaymentRecord>
            {/* <Billing products={products}></Billing> */}
          </div>
        )}
        {activeTab === 3 && (
          <div>
            <Fulfillment  products={products}></Fulfillment>
          </div>
        )}
        {activeTab === 4 && (
          <div>
              <CustomerView products={products}></CustomerView>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectDetails;
